export default __webpack_public_path__ + "static/media/searchIconMobile.0efe2fd4.svg";